import { BaseHubAvatar, BaseHubAvatarProps } from '~/components/basehub-avatar'
import { useUsernameFromId } from '~/hooks/use-username-from-id'
import { SimpleTooltip } from '~/sotano-kit/primitives/tooltip'

export const CommitAuthorAvatar = ({
  authorId,
  size = 'small',
}: {
  authorId: string
  size?: BaseHubAvatarProps['size']
}) => {
  const { username, systemAuthor } = useUsernameFromId(authorId)

  return (
    <SimpleTooltip content={username}>
      <div className="shrink-0">
        <BaseHubAvatar
          name={username}
          {...(systemAuthor ? { forceSrc: systemAuthor.iconUrl } : {})}
          id={authorId}
          size={size}
          className="select-none border border-dark-border"
        />
      </div>
    </SimpleTooltip>
  )
}
